// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk } from 'types';

export const LOAD_ASSIGNMENTS = 'LOAD_ASSIGNMENTS';
export const loadAssignments = (): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_ASSIGNMENTS,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'get',
      url: 'api/assignment',
    },
  });
};

export const CREATE_ASSIGNMENT = 'CREATE_ASSIGNMENT';
export const createAssignment = (
  title: string,
  description: string,
  images: Array<string>,
  assignees: Array<string>
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: CREATE_ASSIGNMENT,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'post',
      url: 'api/assignment',
      data: { title, description, images, assignees },
    },
  });
};

export const EDIT_ASSIGNMENT = 'EDIT_ASSIGNMENT';
export const editAssignment = (
  assignmentId: string,
  payload: Object
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: EDIT_ASSIGNMENT,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'put',
      url: 'api/assignment',
      data: { assignmentId, ...payload },
    },
  });
};

export const CREATE_COMMENT = 'CREATE_COMMENT';
export const createComment = (
  assignmentId: string,
  comment: string
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: CREATE_ASSIGNMENT,
    url: '/api/management/firebase',
    method: 'post',
    dispatch,
    body: {
      method: 'post',
      url: 'api/assignment/comment',
      data: { assignmentId, comment },
    },
  });
};



// WEBPACK FOOTER //
// ./src/redux/actions/assignments.js